// extracted by mini-css-extract-plugin
export default {"wrapper":"SwiperComp_wrapper__dEskI","image":"SwiperComp_image__nuH2F"};